import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './Button.scss'

/**
 * Legacy Button. Использовать предпочтительно UnvButton (UnvUI/Button).
 */
const Button = ({
  children,
  onClick = () => {},
  className = '',
  disabled = false,
  active = false,
  type,
  ...attrs
}) => {
  const onClickAction = (e) => {
    if (disabled) {
      e.preventDefault()
      return undefined
    }
    if (typeof onClick === 'function') {
      return onClick(e)
    }
    return undefined
  }

  const classes = classNames('btn', className, { active })

  const isLink = !!attrs.href
  const Tag = isLink ? 'a' : 'button'

  // Для <a> атрибут disabled не валиден — отдадим aria-disabled.
  const tagProps = isLink
    ? {
        ...attrs,
        'aria-disabled': disabled || undefined,
      }
    : {
        ...attrs,
        // Защищаем от случайного submit внутри <form>.
        type: type || 'button',
        disabled,
      }

  return (
    <Tag
      className={classes}
      onClick={onClickAction}
      {...tagProps}
    >
      {children}
    </Tag>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  type: PropTypes.string,
}

export default Button
